import { useQuery } from "react-query";
import type { ApiError } from "@circle-react/config/CustomErrors";
import type { PaginationHelper, Space } from "@circle-react/types";
import { spaceApi } from "../api/spaceApi";

type SpacesApiResponse = PaginationHelper<Space>;

export const useSpacesApi = () => {
  const { data, isLoading, error } = useQuery<SpacesApiResponse, ApiError>({
    queryKey: ["spaces"],
    queryFn: () =>
      spaceApi.list({
        params: { include_sidebar: true },
      }),
  });

  return { data, isLoading, error };
};
